import React, { useState, useEffect } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  CardHeader,
  CardBody,
  CardFooter,
  Table,
  Badge,
  Button,
  Input,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
  Pagination,
  PaginationItem,
  PaginationLink,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  FormGroup,
  Label,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";
import CommonHeader from "components/Headers/CommonHeader.js";
import CustomPagination from "components/Common/CustomPagination";
import LoadingDots from "components/Common/LoadingDots";
import Swal from "sweetalert2";
import {
  FaSlidersH,
  FaStar,
  FaImage,
  FaClock,
  FaPlus,
  FaEdit,
  FaTrash,
  FaEye,
  FaSearch,
  FaBolt,
  FaMapMarkerAlt,
} from "react-icons/fa";

const ITEMS_PER_PAGE = 7;

const DUMMY_CONTENT_ITEMS = [
  {
    id: "CONT-301",
    title: "Tokyo Secret Alleyway Ramen & Izakaya Night Walk",
    type: "Featured Experience", // Featured Experience, Home Screen Banner, Top Guide Spotlight, Last-Minute Deal
    city: "Tokyo, Japan",
    guideName: "Kenji Sato",
    guideAvatar: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=100&auto=format&fit=crop&q=60",
    image: "https://images.unsplash.com/photo-1503899036084-c55cdd92da26?w=400&auto=format&fit=crop&q=60",
    duration: "3.5 Hours",
    price: 65,
    rating: 4.95,
    displayOrder: 1,
    status: "live",
  },
  {
    id: "CONT-302",
    title: "Spring Special: Save 20% on Annual Guide Subscriptions",
    type: "Home Screen Banner",
    city: "Global",
    guideName: "Localmate Official",
    guideAvatar: "",
    image: "https://images.unsplash.com/photo-1488646953014-85cb44e25828?w=400&auto=format&fit=crop&q=60",
    duration: "Ongoing",
    price: 99.99,
    rating: 5.0,
    displayOrder: 1,
    status: "live",
  },
  {
    id: "CONT-303",
    title: "Paris Hidden Artisan Bakeries & Pastry Tasting",
    type: "Featured Experience",
    city: "Paris, France",
    guideName: "Amélie Laurent",
    guideAvatar: "https://images.unsplash.com/photo-1517841905240-472988babdf9?w=100&auto=format&fit=crop&q=60",
    image: "https://images.unsplash.com/photo-1502602898657-3e91760cbb34?w=400&auto=format&fit=crop&q=60",
    duration: "2.5 Hours",
    price: 55,
    rating: 4.98,
    displayOrder: 2,
    status: "live",
  },
  {
    id: "CONT-304",
    title: "Rome Colosseum Underground by Twilight Walk",
    type: "Last-Minute Deal",
    city: "Rome, Italy",
    guideName: "Matteo Romano",
    guideAvatar: "https://images.unsplash.com/photo-1506794778202-cad84cf45f1d?w=100&auto=format&fit=crop&q=60",
    image: "https://images.unsplash.com/photo-1552832230-c0197dd311b5?w=400&auto=format&fit=crop&q=60",
    duration: "3.0 Hours",
    price: 45,
    rating: 4.92,
    displayOrder: 3,
    status: "live",
  },
  {
    id: "CONT-305",
    title: "Gothic Quarter Secret Tapas & Wine Crawl",
    type: "Featured Experience",
    city: "Barcelona, Spain",
    guideName: "Sofia Mendez",
    guideAvatar: "https://images.unsplash.com/photo-1534528741775-53994a69daeb?w=100&auto=format&fit=crop&q=60",
    image: "https://images.unsplash.com/photo-1583422409516-2895a77efded?w=400&auto=format&fit=crop&q=60",
    duration: "3.0 Hours",
    price: 50,
    rating: 4.9,
    displayOrder: 4,
    status: "live",
  },
  {
    id: "CONT-306",
    title: "Top Rated Local Guide Spotlight: Marcus Vance (London)",
    type: "Top Guide Spotlight",
    city: "London, UK",
    guideName: "Marcus Vance",
    guideAvatar: "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=100&auto=format&fit=crop&q=60",
    image: "https://images.unsplash.com/photo-1513635269975-59663e0ac1ad?w=400&auto=format&fit=crop&q=60",
    duration: "Hourly $52",
    price: 52,
    rating: 5.0,
    displayOrder: 5,
    status: "live",
  },
];

const ContentManagement = () => {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState("");
  const [typeFilter, setTypeFilter] = useState("all");
  const [currentPage, setCurrentPage] = useState(1);
  const [modalOpen, setModalOpen] = useState(false);
  const [editingItem, setEditingItem] = useState(null);
  const [previewItem, setPreviewItem] = useState(null);

  const [formData, setFormData] = useState({
    title: "",
    type: "Featured Experience",
    city: "Tokyo, Japan",
    guideName: "",
    duration: "3 Hours",
    price: 50,
    image: "",
    displayOrder: 1,
    status: "live",
  });

  useEffect(() => {
    setLoading(true);
    const timer = setTimeout(() => {
      setItems(DUMMY_CONTENT_ITEMS);
      setLoading(false);
    }, 400);
    return () => clearTimeout(timer);
  }, []);

  const filteredItems = items.filter((item) => {
    const matchesSearch =
      item.title.toLowerCase().includes(searchTerm.toLowerCase()) ||
      item.city.toLowerCase().includes(searchTerm.toLowerCase()) ||
      item.guideName.toLowerCase().includes(searchTerm.toLowerCase());

    const matchesType =
      typeFilter === "all" ? true : item.type.toLowerCase().includes(typeFilter.toLowerCase());

    return matchesSearch && matchesType;
  });

  const totalPages = Math.ceil(filteredItems.length / ITEMS_PER_PAGE) || 1;
  const paginatedItems = filteredItems.slice(
    (currentPage - 1) * ITEMS_PER_PAGE,
    currentPage * ITEMS_PER_PAGE
  );

  const handleOpenAddModal = () => {
    setEditingItem(null);
    setFormData({
      title: "",
      type: "Featured Experience",
      city: "Tokyo, Japan",
      guideName: "Local Guide",
      duration: "3 Hours",
      price: 50,
      image: "https://images.unsplash.com/photo-1503899036084-c55cdd92da26?w=400&auto=format&fit=crop&q=60",
      displayOrder: items.length + 1,
      status: "live",
    });
    setModalOpen(true);
  };

  const handleOpenEditModal = (item) => {
    setEditingItem(item);
    setFormData({
      title: item.title,
      type: item.type,
      city: item.city,
      guideName: item.guideName,
      duration: item.duration,
      price: item.price,
      image: item.image,
      displayOrder: item.displayOrder,
      status: item.status,
    });
    setModalOpen(true);
  };

  const handleSaveItem = () => {
    if (!formData.title.trim()) {
      Swal.fire("Required", "Title is required.", "warning");
      return;
    }

    if (editingItem) {
      setItems((prev) =>
        prev.map((i) =>
          i.id === editingItem.id
            ? {
                ...i,
                title: formData.title,
                type: formData.type,
                city: formData.city,
                guideName: formData.guideName,
                duration: formData.duration,
                price: Number(formData.price),
                image: formData.image,
                displayOrder: Number(formData.displayOrder),
                status: formData.status,
              }
            : i
        )
      );
      Swal.fire("Updated!", "Content item saved.", "success");
    } else {
      const newItem = {
        id: `CONT-${Date.now().toString().slice(-3)}`,
        title: formData.title,
        type: formData.type,
        city: formData.city,
        guideName: formData.guideName,
        guideAvatar: "https://images.unsplash.com/photo-1534528741775-53994a69daeb?w=100&auto=format&fit=crop&q=60",
        image: formData.image,
        duration: formData.duration,
        price: Number(formData.price),
        rating: 5.0,
        displayOrder: Number(formData.displayOrder),
        status: formData.status,
      };
      setItems((prev) => [newItem, ...prev]);
      Swal.fire("Added!", "Content item published to app feed.", "success");
    }
    setModalOpen(false);
  };

  const handleDeleteItem = (id) => {
    Swal.fire({
      title: "Remove Item?",
      text: "This item will be removed from the Home Screen feed.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      confirmButtonText: "Remove",
    }).then((res) => {
      if (res.isConfirmed) {
        setItems((prev) => prev.filter((i) => i.id !== id));
        Swal.fire("Deleted!", "Item removed.", "success");
      }
    });
  };

  return (
    <>
      <CommonHeader />
      <Container className="mt--7" fluid>
        {/* Metric Cards */}
        <Row className="mb-4">
          <Col lg="3" md="6">
            <Card
              className="card-stats mb-4 mb-xl-0 shadow-sm border-0"
              role="button"
              tabIndex={0}
              onClick={() => {
                setTypeFilter("banner");
                setCurrentPage(1);
              }}
              style={{
                cursor: "pointer",
                transition: "all 0.2s ease-in-out",
                border:
                  typeFilter === "banner"
                    ? "2px solid #5e72e4"
                    : "1px solid transparent",
                transform: typeFilter === "banner" ? "translateY(-3px)" : "none",
              }}
            >
              <CardBody>
                <Row>
                  <div className="col">
                    <h5 className="text-uppercase text-muted mb-0 font-weight-bold">
                      Active Home Banners
                    </h5>
                    <span className="h2 font-weight-bold mb-0">6 Live</span>
                  </div>
                  <Col className="col-auto">
                    <div className="icon icon-shape bg-primary text-white rounded-circle shadow">
                      <FaImage />
                    </div>
                  </Col>
                </Row>
                <p className="mt-3 mb-0 text-muted text-sm">
                  <span className="text-success mr-2 font-weight-bold">Top Carousels</span>
                  <span>Active</span>
                </p>
              </CardBody>
            </Card>
          </Col>
          <Col lg="3" md="6">
            <Card
              className="card-stats mb-4 mb-xl-0 shadow-sm border-0"
              role="button"
              tabIndex={0}
              onClick={() => {
                setTypeFilter("featured_exp");
                setCurrentPage(1);
              }}
              style={{
                cursor: "pointer",
                transition: "all 0.2s ease-in-out",
                border:
                  typeFilter === "featured_exp"
                    ? "2px solid #2dce89"
                    : "1px solid transparent",
                transform:
                  typeFilter === "featured_exp" ? "translateY(-3px)" : "none",
              }}
            >
              <CardBody>
                <Row>
                  <div className="col">
                    <h5 className="text-uppercase text-muted mb-0 font-weight-bold">
                      Featured Experiences
                    </h5>
                    <span className="h2 font-weight-bold mb-0">18 Tours</span>
                  </div>
                  <Col className="col-auto">
                    <div className="icon icon-shape bg-success text-white rounded-circle shadow">
                      <FaStar />
                    </div>
                  </Col>
                </Row>
                <p className="mt-3 mb-0 text-muted text-sm">
                  <span className="text-success mr-2 font-weight-bold">Curated</span>
                  <span>Top conversion</span>
                </p>
              </CardBody>
            </Card>
          </Col>
          <Col lg="3" md="6">
            <Card
              className="card-stats mb-4 mb-xl-0 shadow-sm border-0"
              role="button"
              tabIndex={0}
              onClick={() => {
                setTypeFilter("top_guide");
                setCurrentPage(1);
              }}
              style={{
                cursor: "pointer",
                transition: "all 0.2s ease-in-out",
                border:
                  typeFilter === "top_guide"
                    ? "2px solid #fb6340"
                    : "1px solid transparent",
                transform:
                  typeFilter === "top_guide" ? "translateY(-3px)" : "none",
              }}
            >
              <CardBody>
                <Row>
                  <div className="col">
                    <h5 className="text-uppercase text-muted mb-0 font-weight-bold">
                      Guide Spotlights
                    </h5>
                    <span className="h2 font-weight-bold mb-0">24 Guides</span>
                  </div>
                  <Col className="col-auto">
                    <div className="icon icon-shape bg-warning text-white rounded-circle shadow">
                      <FaSlidersH />
                    </div>
                  </Col>
                </Row>
                <p className="mt-3 mb-0 text-muted text-sm">
                  <span className="text-warning mr-2 font-weight-bold">Featured badge</span>
                  <span>Promoted</span>
                </p>
              </CardBody>
            </Card>
          </Col>
          <Col lg="3" md="6">
            <Card
              className="card-stats mb-4 mb-xl-0 shadow-sm border-0"
              role="button"
              tabIndex={0}
              onClick={() => {
                setTypeFilter("deal");
                setCurrentPage(1);
              }}
              style={{
                cursor: "pointer",
                transition: "all 0.2s ease-in-out",
                border:
                  typeFilter === "deal"
                    ? "2px solid #f5365c"
                    : "1px solid transparent",
                transform: typeFilter === "deal" ? "translateY(-3px)" : "none",
              }}
            >
              <CardBody>
                <Row>
                  <div className="col">
                    <h5 className="text-uppercase text-muted mb-0 font-weight-bold">
                      Last-Minute Deals
                    </h5>
                    <span className="h2 font-weight-bold mb-0">15 Deals</span>
                  </div>
                  <Col className="col-auto">
                    <div className="icon icon-shape bg-danger text-white rounded-circle shadow">
                      <FaBolt />
                    </div>
                  </Col>
                </Row>
                <p className="mt-3 mb-0 text-muted text-sm">
                  <span className="text-danger mr-2 font-weight-bold">Instant Book</span>
                  <span>Available today</span>
                </p>
              </CardBody>
            </Card>
          </Col>
        </Row>

        {/* Main Table Card */}
        <Row>
          <div className="col">
            <Card className="shadow border-0">
              <CardHeader className="border-0 d-flex flex-column flex-md-row justify-content-between align-items-md-center gap-3">
                <div>
                  <h3 className="mb-0 text-primary-new font-weight-bold">
                    Home Screen & Content Management
                  </h3>
                  <small className="text-muted">
                    Curate featured experiences, trending highlights, top guide spotlights & promotional banners
                  </small>
                </div>
                <div className="d-flex flex-wrap align-items-center gap-2 mt-3 mt-md-0">
                  <InputGroup className="input-group-alternative" style={{ width: "240px" }}>
                    <InputGroupAddon addonType="prepend">
                      <InputGroupText>
                        <FaSearch className="text-muted" />
                      </InputGroupText>
                    </InputGroupAddon>
                    <Input
                      placeholder="Search content, guide, city..."
                      type="text"
                      value={searchTerm}
                      onChange={(e) => {
                        setSearchTerm(e.target.value);
                        setCurrentPage(1);
                      }}
                    />
                  </InputGroup>

                  <Input
                    type="select"
                    style={{ width: "180px" }}
                    value={typeFilter}
                    onChange={(e) => {
                      setTypeFilter(e.target.value);
                      setCurrentPage(1);
                    }}
                    className="custom-select"
                  >
                    <option value="all">All Content Types</option>
                    <option value="featured">Featured Experiences</option>
                    <option value="banner">Home Banners</option>
                    <option value="spotlight">Top Guide Spotlights</option>
                    <option value="deal">Last-Minute Deals</option>
                  </Input>

                  <Button color="primary" onClick={handleOpenAddModal} className="d-flex align-items-center">
                    <FaPlus className="mr-1" /> Add Content Item
                  </Button>
                </div>
              </CardHeader>

              {loading ? (
                <div className="py-5 text-center">
                  <LoadingDots message="Loading content catalog..." />
                </div>
              ) : (
                <Table className="align-items-center table-flush" responsive hover>
                  <thead className="thead-light">
                    <tr>
                      <th scope="col">Content Item</th>
                      <th scope="col">Type</th>
                      <th scope="col">City & Guide</th>
                      <th scope="col">Duration & Price</th>
                      <th scope="col">Order</th>
                      <th scope="col">Status</th>
                      <th scope="col" className="text-right">Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {paginatedItems.length > 0 ? (
                      paginatedItems.map((item) => (
                        <tr key={item.id}>
                          <td style={{ maxWidth: "260px" }}>
                            <div className="d-flex align-items-center">
                              <img
                                src={item.image}
                                alt={item.title}
                                className="rounded mr-3 shadow-sm"
                                style={{ width: "50px", height: "40px", objectFit: "cover" }}
                              />
                              <div>
                                <span className="mb-0 text-sm font-weight-bold d-block text-truncate" title={item.title}>
                                  {item.title}
                                </span>
                                <small className="text-primary font-weight-bold">{item.id}</small>
                              </div>
                            </div>
                          </td>
                          <td>
                            <Badge color="info" pill className="p-2">
                              {item.type}
                            </Badge>
                          </td>
                          <td>
                            <span className="font-weight-bold text-dark d-block">
                              <FaMapMarkerAlt className="text-danger mr-1" /> {item.city}
                            </span>
                            <small className="text-muted">{item.guideName}</small>
                          </td>
                          <td>
                            <span className="font-weight-bold text-success">${item.price}</span>
                            <div className="small text-muted">{item.duration}</div>
                          </td>
                          <td>
                            <Badge color="light" className="p-2 border font-weight-bold">
                              #{item.displayOrder}
                            </Badge>
                          </td>
                          <td>
                            {item.status === "live" ? (
                              <Badge color="success" className="badge-dot mr-4">
                                <i className="bg-success" /> Live Feed
                              </Badge>
                            ) : (
                              <Badge color="warning" className="badge-dot mr-4">
                                <i className="bg-warning" /> Draft
                              </Badge>
                            )}
                          </td>
                          <td className="text-right">
                            <UncontrolledDropdown>
                              <DropdownToggle
                                className="btn-icon-only text-light"
                                href="#pablo"
                                role="button"
                                size="sm"
                                color=""
                                onClick={(e) => e.preventDefault()}
                              >
                                <i className="fas fa-ellipsis-v" />
                              </DropdownToggle>
                              <DropdownMenu className="dropdown-menu-arrow" right>
                                <DropdownItem onClick={() => setPreviewItem(item)}>
                                  <FaEye className="mr-2 text-primary" /> Preview in App Mockup
                                </DropdownItem>
                                <DropdownItem onClick={() => handleOpenEditModal(item)}>
                                  <FaEdit className="mr-2 text-info" /> Edit Content
                                </DropdownItem>
                                <DropdownItem divider />
                                <DropdownItem onClick={() => handleDeleteItem(item.id)}>
                                  <FaTrash className="mr-2 text-danger" /> Remove
                                </DropdownItem>
                              </DropdownMenu>
                            </UncontrolledDropdown>
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="7" className="text-center py-4 text-muted">
                          No content items found.
                        </td>
                      </tr>
                    )}
                  </tbody>
                </Table>
              )}

              {/* Unified Pagination */}
              {!loading && filteredItems.length > 0 && (
                <CardFooter className="py-4 border-0">
                  <CustomPagination
                    currentPage={currentPage}
                    totalPages={totalPages}
                    totalItems={filteredItems.length}
                    itemsPerPage={ITEMS_PER_PAGE}
                    onPageChange={(page) => setCurrentPage(page)}
                    itemName="items"
                  />
                </CardFooter>
              )}
            </Card>
          </div>
        </Row>

        {/* Add/Edit Modal */}
        <Modal isOpen={modalOpen} toggle={() => setModalOpen(!modalOpen)} size="lg" centered>
          <ModalHeader toggle={() => setModalOpen(!modalOpen)} className="bg-light border-bottom">
            <span className="font-weight-bold text-dark">
              {editingItem ? `Edit Content: ${editingItem.title}` : "Add New Experience / Banner"}
            </span>
          </ModalHeader>
          <ModalBody className="p-4">
            <FormGroup>
              <Label className="font-weight-bold">Experience Title / Banner Heading</Label>
              <Input
                type="text"
                value={formData.title}
                onChange={(e) => setFormData({ ...formData, title: e.target.value })}
              />
            </FormGroup>

            <Row>
              <Col md="6">
                <FormGroup>
                  <Label className="font-weight-bold">Content Type</Label>
                  <Input
                    type="select"
                    value={formData.type}
                    onChange={(e) => setFormData({ ...formData, type: e.target.value })}
                  >
                    <option value="Featured Experience">Featured Experience</option>
                    <option value="Home Screen Banner">Home Screen Banner</option>
                    <option value="Top Guide Spotlight">Top Guide Spotlight</option>
                    <option value="Last-Minute Deal">Last-Minute Deal</option>
                  </Input>
                </FormGroup>
              </Col>
              <Col md="6">
                <FormGroup>
                  <Label className="font-weight-bold">Target City</Label>
                  <Input
                    type="text"
                    value={formData.city}
                    onChange={(e) => setFormData({ ...formData, city: e.target.value })}
                  />
                </FormGroup>
              </Col>
            </Row>

            <Row>
              <Col md="4">
                <FormGroup>
                  <Label className="font-weight-bold">Featured Guide Name</Label>
                  <Input
                    type="text"
                    value={formData.guideName}
                    onChange={(e) => setFormData({ ...formData, guideName: e.target.value })}
                  />
                </FormGroup>
              </Col>
              <Col md="4">
                <FormGroup>
                  <Label className="font-weight-bold">Duration</Label>
                  <Input
                    type="text"
                    value={formData.duration}
                    onChange={(e) => setFormData({ ...formData, duration: e.target.value })}
                  />
                </FormGroup>
              </Col>
              <Col md="4">
                <FormGroup>
                  <Label className="font-weight-bold">Price ($ USD)</Label>
                  <Input
                    type="number"
                    value={formData.price}
                    onChange={(e) => setFormData({ ...formData, price: e.target.value })}
                  />
                </FormGroup>
              </Col>
            </Row>

            <FormGroup>
              <Label className="font-weight-bold">Cover Image URL</Label>
              <Input
                type="text"
                value={formData.image}
                onChange={(e) => setFormData({ ...formData, image: e.target.value })}
              />
            </FormGroup>

            <Row>
              <Col md="6">
                <FormGroup>
                  <Label className="font-weight-bold">Display Order Priority</Label>
                  <Input
                    type="number"
                    value={formData.displayOrder}
                    onChange={(e) => setFormData({ ...formData, displayOrder: e.target.value })}
                  />
                </FormGroup>
              </Col>
              <Col md="6">
                <FormGroup>
                  <Label className="font-weight-bold">Status</Label>
                  <Input
                    type="select"
                    value={formData.status}
                    onChange={(e) => setFormData({ ...formData, status: e.target.value })}
                  >
                    <option value="live">Live in App Feed</option>
                    <option value="draft">Draft / Hidden</option>
                  </Input>
                </FormGroup>
              </Col>
            </Row>
          </ModalBody>
          <ModalFooter className="bg-light">
            <Button color="secondary" onClick={() => setModalOpen(false)}>
              Cancel
            </Button>
            <Button color="primary" onClick={handleSaveItem}>
              Save Item
            </Button>
          </ModalFooter>
        </Modal>

        {/* Preview Modal */}
        {previewItem && (
          <Modal isOpen={Boolean(previewItem)} toggle={() => setPreviewItem(null)} size="md" centered>
            <ModalHeader toggle={() => setPreviewItem(null)} className="bg-light border-bottom">
              <span className="font-weight-bold text-dark">Mobile App Preview</span>
            </ModalHeader>
            <ModalBody className="p-4 text-center">
              <div
                className="rounded shadow-lg overflow-hidden border mx-auto text-left"
                style={{ maxWidth: "340px", backgroundColor: "#fff" }}
              >
                <img
                  src={previewItem.image}
                  alt={previewItem.title}
                  style={{ width: "100%", height: "180px", objectFit: "cover" }}
                />
                <div className="p-3">
                  <Badge color="primary" className="mb-2">{previewItem.type}</Badge>
                  <h4 className="font-weight-bold text-dark mb-1">{previewItem.title}</h4>
                  <p className="text-muted small mb-2">
                    <FaMapMarkerAlt className="text-danger mr-1" /> {previewItem.city} • By {previewItem.guideName}
                  </p>
                  <div className="d-flex justify-content-between align-items-center pt-2 border-top">
                    <div>
                      <span className="text-success font-weight-bold h5 mb-0">${previewItem.price}</span>
                      <small className="text-muted d-block">{previewItem.duration}</small>
                    </div>
                    <Button size="sm" color="primary" className="btn-round">
                      Book with Local
                    </Button>
                  </div>
                </div>
              </div>
            </ModalBody>
            <ModalFooter className="bg-light">
              <Button color="secondary" onClick={() => setPreviewItem(null)}>
                Close Preview
              </Button>
            </ModalFooter>
          </Modal>
        )}
      </Container>
    </>
  );
};

export default ContentManagement;
